import { Box, MenuItem, Stack, Typography } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { DropdownNestedItem } from "../../../../../types/genereal";
import { AccordionArrowDown } from "../../../../images/AccordionArrowDown";

type Props = {
  item: DropdownNestedItem;
  children: ReactNode;
  selectedChildCount: number;
  initOpen?: boolean;
};

export const DropdownParentItem = ({
  item,
  children,
  selectedChildCount,
  initOpen,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (initOpen !== undefined) setIsOpen(initOpen);
  }, [initOpen]);

  const toogleAccordion = () => setIsOpen(!isOpen);

  return (
    <>
      <MenuItem
        sx={{
          display: "flex",
          padding: "8px 16px",
          cursor: "pointer",
          width: "100%",
          justifyContent: "space-between",
          gap: "12px",
          position: "relative",
        }}
        onClick={toogleAccordion}
      >
        <Stack flexDirection="row" gap="4px" alignItems="center">
          <Typography
            component="span"
            variant="button"
            color="custom.textDarkBlue"
          >
            {item.name}
          </Typography>

          {item.nestedItems.length > 0 && (
            <Typography
              component="span"
              variant="body1"
              color="#9FA0A2"
              fontWeight={500}
            >
              {selectedChildCount > 0
                ? `(${selectedChildCount} of ${item.nestedItems.length})`
                : `(${item.nestedItems.length})`}
            </Typography>
          )}
        </Stack>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        >
          <AccordionArrowDown />
        </Box>
      </MenuItem>

      {isOpen && <Stack>{children}</Stack>}
    </>
  );
};
